import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    loadError: "No se pudo cargar dónde verla.",
    showingFor: (country: string) => `Mostrando resultados para ${country}. ¿No es correcto?`,
    searching: "Buscando dónde verla...",
    notFound: (isSeries: boolean, country: string) =>
      `No encontramos ${isSeries ? "esta serie" : "esta película"} en plataformas de streaming en ${country} por ahora.`,
    streaming: "Streaming",
    rentOrBuy: "Renta o compra",
  },
  en: {
    loadError: "Couldn't load where to watch it.",
    showingFor: (country: string) => `Showing results for ${country}. Not right?`,
    searching: "Finding where to watch it...",
    notFound: (isSeries: boolean, country: string) =>
      `We couldn't find this ${isSeries ? "series" : "movie"} on streaming platforms in ${country} right now.`,
    streaming: "Streaming",
    rentOrBuy: "Rent or buy",
  },
});
